import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import { DeleteJobDialogViewModel } from './DeleteJobDialogViewModel'
import Button from '../../../../../components/Button'
import styles from './DeleteJobDialogAsAdmin.sass'

interface DeleteJobDialogProps {
  vm: DeleteJobDialogViewModel
}

const modal = observer(({ vm }: DeleteJobDialogProps) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <div className={styles.contentBlock}>
          <ModalSheetContentIllustration
            src={require('assets/images/img_missing-permissions.svg')}
            alt="Illustration of hand holding a STOP symbol"
          />
          <ModalSheetContentTitle compact>
            <span className={styles.title}>
              Do you really want to delete this job?
            </span>
          </ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            Documents within this job will be deleted if they are not linked
            anywhere else. I hope you know what you're doing.
          </ModalSheetContentDescription>
        </div>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="danger"
            data-test="delete-job-as-admin-submit-button"
            onClick={vm.delete}
          >
            Delete Forever
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default modal
